export default __webpack_public_path__ + "static/media/Boots of the Black Dragon.a5311734.jpg";